(($, Drupal) => {
  Drupal.behaviors.mobSlider = {
    attach: function attch(context) {
      const item = $('.article-selection .article-selection__inner .article-selection__list.js-article-selection-slider li');
      let tallestDiv = 0;

      item.once('checkArticleListWidth').each((index, element) => {
        if ($(element).height() > tallestDiv) {
          tallestDiv = $(element).height();
        }
      });

      // 297 is the smallest the div can be, taken from maquette
      if (tallestDiv > 297) {
        item.height(tallestDiv);
      }

      if (window.matchMedia('(max-width: 1024px)').matches) {
        $('.js-article-selection-slider', context).once('slider').each((index, element) => {
          $(element).slick({
            arrows: false,
            dots: true,
            autoplay: true,
            draggable: true,
            speed: 1000,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          });
        });
      }
    },
  };
})(jQuery, Drupal);
